(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["addtocart"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", () => {
	const forms = document.querySelectorAll("[data-action-addtocart]");

	forms.forEach(function(form) {
		form.addEventListener("submit", async (e) => {
			e.preventDefault();

			const button = form.querySelector("button[type='submit']");
			if (!button || button.disabled) return;

			const originalText = button.innerHTML;
			button.disabled = true;
			button.innerHTML = "Adding...";

			try {
			const formData = new FormData(form);

			const response = await fetch("/cart/add.js", {
				method: "POST",
				headers: {
					"Accept": "application/json"
				},
				body: formData
			});

			if (!response.ok) {
				const errorData = await response.json();
				throw new Error(errorData.description || "Failed to add to cart");
			}

			const addedItem = await response.json();

			const cartRes = await fetch("/cart.js");
			const cartData = await cartRes.json();

			const cartCountEls = document.querySelectorAll("[data-cart-count]");
			cartCountEls.forEach(el => {
				el.textContent = cartData.item_count;
			});

			document.dispatchEvent(new CustomEvent("ajax:cart-added", {
				detail: {
					item: addedItem,
					cart: cartData
				}
			}));

			button.innerHTML = "Added!";

			/*
			setTimeout(() => {
				button.innerHTML = originalText;
				button.disabled = false;
			}, 1200);
			*/
			window.location.reload();
			

			} catch (err) {
				console.error("AJAX Add to Cart Error:", err);

				button.innerHTML = "Error";
				setTimeout(() => {
					button.innerHTML = originalText;
					button.disabled = false;
				}, 1500);

				alert(err.message);
			}
		});
	});
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-item"] && !Shopify.designMode) return;
  try {
    "use strict";

document.addEventListener("DOMContentLoaded", function() {
	document.querySelectorAll('.cta-remove-cartitem[data-cart-key]').forEach(function(ctaRemoveCart) {
		const cartItemDom = ctaRemoveCart.closest(".cart-item");
		const cartKey = ctaRemoveCart.getAttribute('data-cart-key');

		if(cartItemDom && cartKey) {
			ctaRemoveCart.addEventListener('click', async function() {
				try {
					cartItemDom.setAttribute('data-loading', '');

					const res = await fetch("/cart/change.js", {
						method: "POST",
						headers: {
							"Content-Type": "application/json",
							"Accept": "application/json"
						},
						body: JSON.stringify({
							id: cartKey,
							quantity: 0
						})
					});

					if (!res.ok) throw new Error("Failed to remove item");

					const cart = await res.json();

					if(typeof refreshCart === 'function') {
						refreshCart(cart);
					}

					cartItemDom.remove();
				} catch (err) {
					console.error(err);
					cartItemDom.removeAttribute('data-loading');
				}	
			});
		}
	});
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["collapsible-faq"] && !Shopify.designMode) return;
  try {
    "use strict";

document.addEventListener("DOMContentLoaded", function() {
    document.querySelectorAll("[data-action-collapsible]").forEach(function(ctaCollapsible) {
        ctaCollapsible.addEventListener('click', function(e) {
            const current = e.target;

            const collapsiblefaq = e.target.closest(".collapsible-faq");

            if(collapsiblefaq) {
                if(collapsiblefaq.hasAttribute('data-collapsible-faq-open')) {
                    collapsiblefaq.removeAttribute('data-collapsible-faq-open');
                } else {
                    collapsiblefaq.setAttribute('data-collapsible-faq-open', '');
                }
            }
        })
    })
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["content-readmore"] && !Shopify.designMode) return;
  try {
    "use strict";

document.addEventListener("DOMContentLoaded", function() {
	document.querySelectorAll(".content-readmore").forEach(function(contentReadmore) {
		const styles = getComputedStyle(contentReadmore);
		const maxHeight = Number(styles.getPropertyValue("--maxheight").replace(/px$/, "")) || 56;
		const spaceHeight = Number(styles.getPropertyValue("--size-space").replace(/px$/, "")) || 48;
		const readmoreMaxheight = maxHeight + spaceHeight + 20;

		if(contentReadmore.clientHeight > readmoreMaxheight) {
			contentReadmore.setAttribute('data-readmore-state', 'close')

			contentReadmore.querySelectorAll('.cta-readmore').forEach(function(ctaReadmore) {
				ctaReadmore.addEventListener('click', function() {
					contentReadmore.setAttribute('data-readmore-state', ctaReadmore.getAttribute('data-readmore-action'))
				})
			})
		} else {
			contentReadmore.removeAttribute('data-readmore-state')
		}
	})
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["input-quantity"] && !Shopify.designMode) return;
  try {
    "use strict";

document.addEventListener("DOMContentLoaded", function() {
	async function updateCartItemQuantity(key, quantity) {
		const res = await fetch("/cart/change.js", {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				"Accept": "application/json"
			},
			body: JSON.stringify({
				id: key,
				quantity: quantity
			})
		});

		if (!res.ok) throw new Error("Cart update failed");

		const cart = await res.json();

		if(typeof refreshCart === 'function') {
			refreshCart(cart);
		}
	}

	function getNumber(value, fallback) {
		const parsed = parseInt(value, 10);
		return Number.isFinite(parsed) ? parsed : fallback;
	}

	function getQuantityMax(formQuantity, fieldQuantity) {
		const rawMax = formQuantity.getAttribute("data-qty-max") || fieldQuantity.getAttribute("max");

		if (rawMax === null || rawMax === "") return null;

		const parsedMax = parseInt(rawMax, 10);
		return Number.isFinite(parsedMax) ? parsedMax : null;
	}

	function clampQuantity(formQuantity, fieldQuantity, value) {
		const min = getNumber(fieldQuantity.getAttribute("min"), 0);
		const max = getQuantityMax(formQuantity, fieldQuantity);
		let clampedValue = getNumber(value, min);

		if (clampedValue < min) clampedValue = min;
		if (max !== null && clampedValue > max) clampedValue = max;

		return clampedValue;
	}

	function setButtonState(button, disabled) {
		if (!button) return;

		if (disabled) {
			button.setAttribute("aria-disabled", "");
			button.disabled = true;
		} else {
			button.removeAttribute("aria-disabled");
			button.disabled = false;
		}
	}

	function updateQuantityState(formQuantity) {
		const fieldQuantity = formQuantity.querySelector("[data-qty-input]");
		const ctaUpdateDecrement = formQuantity.querySelector("[data-qty-minus]");
		const ctaUpdateIncrement = formQuantity.querySelector("[data-qty-plus]");
		if (!fieldQuantity) return;

		const min = getNumber(fieldQuantity.getAttribute("min"), 0);
		const max = getQuantityMax(formQuantity, fieldQuantity);
		const valueQuantity = clampQuantity(formQuantity, fieldQuantity, fieldQuantity.value);

		fieldQuantity.value = valueQuantity;
		setButtonState(ctaUpdateDecrement, valueQuantity <= min);
		setButtonState(ctaUpdateIncrement, max !== null && valueQuantity >= max);
	}

	function syncAddToCartQuantity(formQuantity) {
		if (formQuantity.getAttribute("action") === "/cart/update") return;

		const fieldQuantity = formQuantity.querySelector("[data-qty-input]");
		if (!fieldQuantity) return;

		const valueQuantity = clampQuantity(formQuantity, fieldQuantity, fieldQuantity.value);
		const action = formQuantity.closest(".action-main-product, .action-simple-product");
		const scopedAddToCart = action ? action.querySelector('[data-action-addtocart] input[name="quantity"]') : null;

		fieldQuantity.value = valueQuantity;

		if (scopedAddToCart) {
			scopedAddToCart.value = valueQuantity;
		}

		if (formQuantity.closest(".action-main-product")) {
			document.querySelectorAll('.main-product-addtocart input[name="quantity"]').forEach(function(quantityInput) {
				quantityInput.value = valueQuantity;
			});

			document.querySelectorAll('.action-main-product .field-quantity:not([action="/cart/update"])').forEach(function(otherFormQuantity) {
				const otherFieldQuantity = otherFormQuantity.querySelector("[data-qty-input]");

				if (!otherFieldQuantity || otherFormQuantity === formQuantity) return;

				otherFieldQuantity.value = clampQuantity(otherFormQuantity, otherFieldQuantity, valueQuantity);
				updateQuantityState(otherFormQuantity);
			});
		}
	}

	document.querySelectorAll('.field-quantity').forEach(function(formQuantity) {
		const ctaUpdateDecrement = formQuantity.querySelector('[data-qty-minus]');
		const ctaUpdateIncrement = formQuantity.querySelector('[data-qty-plus]');
		const fieldQuantity = formQuantity.querySelector('[data-qty-input]');
		const cartKey = formQuantity.querySelector('[name="key"]')?.value;
		const isCartQuantity = formQuantity.getAttribute("action") === "/cart/update";

		if(!fieldQuantity) return;

		updateQuantityState(formQuantity);
		syncAddToCartQuantity(formQuantity);

		formQuantity.addEventListener("quantity:max-change", function(event) {
			const max = event.detail ? event.detail.max : "";

			if (max === "" || max === null || max === undefined) {
				formQuantity.removeAttribute("data-qty-max");
				fieldQuantity.removeAttribute("max");
			} else {
				formQuantity.setAttribute("data-qty-max", max);
				fieldQuantity.setAttribute("max", max);
			}

			updateQuantityState(formQuantity);
			syncAddToCartQuantity(formQuantity);
		});

		formQuantity.addEventListener("quantity:value-change", function(event) {
			fieldQuantity.value = event.detail ? event.detail.value : fieldQuantity.value;
			updateQuantityState(formQuantity);
			syncAddToCartQuantity(formQuantity);
		});

		if(ctaUpdateDecrement) {
			ctaUpdateDecrement.addEventListener('click', async function() {
				if (ctaUpdateDecrement.disabled) return;

				const valueQuantity = clampQuantity(formQuantity, fieldQuantity, fieldQuantity.value);
				const min = getNumber(fieldQuantity.getAttribute("min"), 0);

				if(valueQuantity <= min) return;

				const newValue = clampQuantity(formQuantity, fieldQuantity, valueQuantity - 1);
				fieldQuantity.value = newValue;
				updateQuantityState(formQuantity);
				syncAddToCartQuantity(formQuantity);

				if(!isCartQuantity || !cartKey) return;

				try {
					formQuantity.setAttribute('data-loading', '');
					await updateCartItemQuantity(cartKey, newValue);
				} catch (err) {
					console.error(err);
					fieldQuantity.value = valueQuantity;
					updateQuantityState(formQuantity);
				} finally {
					formQuantity.removeAttribute('data-loading');
				}
			});
		}

		if(ctaUpdateIncrement) {
			ctaUpdateIncrement.addEventListener('click', async function() {
				if (ctaUpdateIncrement.disabled) return;

				const valueQuantity = clampQuantity(formQuantity, fieldQuantity, fieldQuantity.value);
				const newValue = clampQuantity(formQuantity, fieldQuantity, valueQuantity + 1);

				if(newValue === valueQuantity) {
					updateQuantityState(formQuantity);
					return;
				}

				fieldQuantity.value = newValue;
				updateQuantityState(formQuantity);
				syncAddToCartQuantity(formQuantity);

				if(!isCartQuantity || !cartKey) return;

				try {
					formQuantity.setAttribute('data-loading', '');
					await updateCartItemQuantity(cartKey, newValue);
				} catch (err) {
					console.error(err);
					fieldQuantity.value = valueQuantity;
					updateQuantityState(formQuantity);
				} finally {
					formQuantity.removeAttribute('data-loading');
				}
			});
		}

		fieldQuantity.addEventListener('input', function() {
			updateQuantityState(formQuantity);
			syncAddToCartQuantity(formQuantity);
		});

		fieldQuantity.addEventListener('change', async function(e) {
			const valueQuantity = clampQuantity(formQuantity, fieldQuantity, e.target.value);

			fieldQuantity.value = valueQuantity;
			updateQuantityState(formQuantity);
			syncAddToCartQuantity(formQuantity);

			if(!isCartQuantity || !cartKey) return;

			try {
				formQuantity.setAttribute('data-loading', '');
				await updateCartItemQuantity(cartKey, valueQuantity);
			} catch (err) {
				console.error(err);
				window.location.reload();
			} finally {
				formQuantity.removeAttribute('data-loading');
			}
		});
	});
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mini-cart"] && !Shopify.designMode) return;
  try {
    "use strict";

document.addEventListener("DOMContentLoaded", function() {
	const ctaClose = document.querySelector(".cta-close-mini-cart");
	const miniCart = document.querySelector(".mini-cart");
	const overlayMiniCart = document.querySelector(".overlay-mini-cart");

	if(miniCart) {
		if(ctaClose) {
			ctaClose.addEventListener("click", (e) => {
				document.body.removeAttribute('data-minicart-open');

				if(lenis) {
					lenis.start();
				}
			});
		}

		if(overlayMiniCart) {
			overlayMiniCart.addEventListener("click", (e) => {
				document.body.removeAttribute('data-minicart-open');

				if(lenis) {
					lenis.start();
				}
			});
		}
	}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["podcast-item"] && !Shopify.designMode) return;
  try {
    "use strict";

document.addEventListener("DOMContentLoaded", function () {
	const spotifyIframes = document.querySelectorAll('.podcast-item iframe[data-src]');

	if (!spotifyIframes.length) return;

	const observer = new IntersectionObserver(
		function (entries, obs) {
			entries.forEach(function (entry) {
				if (!entry.isIntersecting) return;

				const iframe = entry.target;
				const dataSrc = iframe.getAttribute("data-src");

				if (dataSrc) {
					iframe.setAttribute("src", dataSrc);
					iframe.removeAttribute("data-src");
				}

				obs.unobserve(iframe);
			});
		},
		{
			root: null,
			threshold: 0.1,
		}
	);

	spotifyIframes.forEach(function (iframe) {
		observer.observe(iframe);
	});
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-variant-options"] && !Shopify.designMode) return;
  try {
    "use strict";

document.addEventListener("DOMContentLoaded", function () {
	const selectors = document.querySelectorAll("[data-product-variant-options]");

	const formatWithDelimiters = function (number, precision, thousands, decimal) {
		if (isNaN(number) || number === null) return "0";

		const preciseNumber = (number / 100.0).toFixed(precision);
		const parts = preciseNumber.split(".");
		const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
		const centsAmount = parts[1] ? decimal + parts[1] : "";

		return dollarsAmount + centsAmount;
	};

	const formatMoney = function (cents, format) {
		if (!format) return "$" + formatWithDelimiters(cents, 2, ",", ".");

		const moneyFormat = format;
		const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
		const formatType = moneyFormat.match(placeholderRegex)?.[1];
		let value = "";

		if (typeof cents === "string") cents = cents.replace(".", "");

		switch (formatType) {
			case "amount":
				value = formatWithDelimiters(cents, 2, ",", ".");
				break;
			case "amount_with_space_separator":
				value = formatWithDelimiters(cents, 2, " ", ".");
				break;
			case "amount_with_comma_separator":
				value = formatWithDelimiters(cents, 2, ".", ",");
				break;
			case "amount_with_apostrophe_separator":
				value = formatWithDelimiters(cents, 2, "'", ".");
				break;
			case "amount_no_decimals":
				value = formatWithDelimiters(cents, 0, ",", ".");
				break;
			case "amount_no_decimals_with_space_separator":
				value = formatWithDelimiters(cents, 0, " ", ".");
				break;
			case "amount_no_decimals_with_comma_separator":
				value = formatWithDelimiters(cents, 0, ".", ",");
				break;
			default:
				value = formatWithDelimiters(cents, 2, ",", ".");
		}

		return moneyFormat.replace(placeholderRegex, value);
	};

	const getVariantOptions = function (variant) {
		if (Array.isArray(variant.options)) return variant.options;

		return [variant.option1, variant.option2, variant.option3].filter(function (option) {
			return option !== null && option !== undefined && option !== "";
		});
	};

	const normalizeOption = function (value) {
		return String(value || "").trim();
	};

	const refreshCurrencyConverter = function () {
		if (window.Shopify?.theme?.currencyConverter && typeof window.Shopify.theme.currencyConverter.init === "function") {
			window.Shopify.theme.currencyConverter.init();
		}
	};

	const createSwatchNode = function (selectedOption) {
		const swatchImage = selectedOption?.getAttribute("data-swatch-image");
		const swatchColor = selectedOption?.getAttribute("data-swatch-color");
		const label = selectedOption?.textContent.trim() || "";

		if (swatchImage) {
			const image = document.createElement("img");
			image.src = swatchImage;
			image.alt = label;
			image.width = 24;
			image.height = 24;
			image.loading = "lazy";
			image.setAttribute("data-product-option-swatch-image", "");
			return image;
		}

		if (swatchColor) {
			const swatch = document.createElement("span");
			swatch.setAttribute("aria-hidden", "true");
			swatch.setAttribute("data-product-option-swatch-color", "");
			swatch.style.backgroundColor = swatchColor;
			return swatch;
		}

		return null;
	};

	const decorateNiceSelect = function (select) {
		const niceSelect = select.nextElementSibling?.classList.contains("nice-select") ? select.nextElementSibling : null;
		const selectedOption = select.options[select.selectedIndex];

		if (!niceSelect || !selectedOption) return;

		niceSelect.classList.add("product-variant-options__nice-select");

		niceSelect.querySelectorAll(".option .extra").forEach(function (extra) {
			const option = extra.closest(".option");

			if (option && option.firstChild !== extra) {
				option.insertBefore(extra, option.firstChild);
			}
		});

		const current = niceSelect.querySelector(".current");
		if (!current) return;

		const swatch = createSwatchNode(selectedOption);
		current.textContent = "";

		if (swatch) {
			current.appendChild(swatch);
		}

		current.appendChild(document.createTextNode(selectedOption.textContent.trim()));
	};

	const initNiceSelect = function (select) {
		if (select.dataset.niceSelectInitialized === "true") {
			decorateNiceSelect(select);
			return;
		}

		if (!window.NiceSelect || typeof window.NiceSelect.bind !== "function") return;

		window.NiceSelect.bind(select, {
			searchable: false,
			placeholder: select.getAttribute("aria-label") || "Select an option",
		});

		select.dataset.niceSelectInitialized = "true";
		decorateNiceSelect(select);
	};

	const getVariantQuantityMax = function (variant) {
		if (!variant || !variant.inventory_management || variant.inventory_policy === "continue") return "";

		return Math.max(Number(variant.inventory_quantity || 0), 0);
	};

	const updateQuantityControls = function (variant) {
		const max = getVariantQuantityMax(variant);

		document.querySelectorAll(".action-main-product .field-quantity").forEach(function (quantityForm) {
			quantityForm.dispatchEvent(new CustomEvent("quantity:max-change", {
				detail: { max },
			}));
		});
	};

	const hydrateInventoryData = function (selector, variants) {
		const inventoryJson = selector.querySelector("[data-product-variant-inventory-json]");
		if (!inventoryJson) return variants;

		let inventoryRows = [];

		try {
			inventoryRows = JSON.parse(inventoryJson.textContent);
		} catch (error) {
			console.error("Product variant inventory JSON could not be parsed.", error);
			return variants;
		}

		const inventoryById = inventoryRows.reduce(function (map, row) {
			map[String(row.id)] = row;
			return map;
		}, {});

		return variants.map(function (variant) {
			return Object.assign({}, variant, inventoryById[String(variant.id)] || {});
		});
	};

	selectors.forEach(function (selector) {
		const variantsJson = selector.querySelector("[data-product-variants-json]");
		if (!variantsJson) return;

		let variants = [];

		try {
			variants = JSON.parse(variantsJson.textContent);
		} catch (error) {
			console.error("Product variants JSON could not be parsed.", error);
			return;
		}

		variants = hydrateInventoryData(selector, variants);

		const variantIds = variants.map(function (variant) {
			return String(variant.id);
		});

		const productSection = selector.closest(".main-product");
		const productForms = Array.from(document.querySelectorAll(".main-product-addtocart[data-action-addtocart]")).filter(function (form) {
			const variantInput = form.querySelector('input[name="id"]');
			return variantInput && variantIds.includes(String(variantInput.value));
		});

		const getSelectedOptions = function () {
			return Array.from(selector.querySelectorAll("[data-option-index]")).map(function (optionGroup) {
				const selectedInput = optionGroup.querySelector("[data-product-option-input]:checked") || optionGroup.querySelector("select[data-product-option-input]");
				return selectedInput ? normalizeOption(selectedInput.value) : "";
			});
		};

		const findSelectedVariant = function () {
			const selectedOptions = getSelectedOptions();

			return variants.find(function (variant) {
				const variantOptions = getVariantOptions(variant);

				return variantOptions.length === selectedOptions.length && variantOptions.every(function (optionValue, index) {
					return normalizeOption(optionValue) === selectedOptions[index];
				});
			});
		};

		const updateForms = function (variant) {
			productForms.forEach(function (form) {
				const variantInput = form.querySelector('input[name="id"]');
				const button = form.querySelector("button");

				if (variantInput && variant) {
					variantInput.value = String(variant.id);
				}

				if (!button || form.classList.contains("cta-addtocart--coming-soon")) return;

				if (!variant) {
					button.disabled = true;
					button.textContent = "Unavailable";
					return;
				}

				if (variant.available) {
					button.disabled = false;
					button.textContent = "Add to cart";
				} else {
					button.disabled = true;
					button.textContent = "Sold out";
				}
			});
		};

		productForms.forEach(function (form) {
			form.addEventListener("submit", function (event) {
				const selectedVariant = findSelectedVariant();

				updateForms(selectedVariant);

				if (!selectedVariant || !selectedVariant.available) {
					event.preventDefault();
					event.stopImmediatePropagation();
				}
			}, true);
		});

		const updatePrice = function (variant) {
			if (!productSection || !variant) return;

			const priceEl = productSection.querySelector(".entry-main-product .product-price");
			if (!priceEl) return;

			const moneyFormat = selector.getAttribute("data-money-format");
			const price = Number(variant.price || 0);
			const comparePrice = Number(variant.compare_at_price || 0);

			if (comparePrice > price) {
				priceEl.innerHTML = [
					'<span class="price price--sale" data-money="' + price + '" data-money-type="sale">',
					formatMoney(price, moneyFormat),
					'</span>',
					'<span class="price price--compare">',
					'<s data-money="' + comparePrice + '" data-money-type="compare">',
					formatMoney(comparePrice, moneyFormat),
					'</s>',
					'</span>',
				].join("");
			} else {
				priceEl.innerHTML = [
					'<span class="price price--regular" data-money="' + price + '" data-money-type="regular">',
					formatMoney(price, moneyFormat),
					'</span>',
				].join("");
			}

			refreshCurrencyConverter();
		};

		const updateThumbnail = function (variant) {
			if (!productSection || !variant) return;

			const featuredImage = variant.featured_image;
			const thumbnail = productSection.querySelector(".thumbnail-product");
			const swiperContainer = thumbnail ? thumbnail.querySelector("swiper-container") : null;

			if (!featuredImage || !swiperContainer) return;

			let targetIndex = -1;

			if (featuredImage.id) {
				const targetSlide = swiperContainer.querySelector('[data-product-image-id="' + featuredImage.id + '"]');

				if (targetSlide) {
					targetIndex = Array.from(swiperContainer.children).indexOf(targetSlide);
				}
			}

			if (targetIndex < 0 && featuredImage.position) {
				targetIndex = Number(featuredImage.position) - 1;
			}

			if (targetIndex < 0) return;

			if (swiperContainer.swiper && typeof swiperContainer.swiper.slideTo === "function") {
				swiperContainer.swiper.slideTo(targetIndex);
				return;
			}

			window.setTimeout(function () {
				if (swiperContainer.swiper && typeof swiperContainer.swiper.slideTo === "function") {
					swiperContainer.swiper.slideTo(targetIndex);
				}
			}, 0);
		};

		const updateSelectedVariant = function () {
			const selectedVariant = findSelectedVariant();

			selector.querySelectorAll("select[data-product-option-input]").forEach(function (select) {
				initNiceSelect(select);
			});

			if (selectedVariant) {
				selector.setAttribute("data-selected-variant-id", selectedVariant.id);
			} else {
				selector.removeAttribute("data-selected-variant-id");
			}

			updateForms(selectedVariant);
			updatePrice(selectedVariant);
			updateThumbnail(selectedVariant);
			updateQuantityControls(selectedVariant);

			selector.dispatchEvent(new CustomEvent("product:variant-change", {
				bubbles: true,
				detail: {
					variant: selectedVariant || null,
					selectedOptions: getSelectedOptions(),
				},
			}));
		};

		selector.querySelectorAll("select[data-product-option-input]").forEach(initNiceSelect);
		selector.addEventListener("change", updateSelectedVariant);
		updateSelectedVariant();
	});
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["thumbnail-product"] && !Shopify.designMode) return;
  try {
    "use strict";

document.addEventListener("DOMContentLoaded", function() {
	document.querySelectorAll('.thumbnail-product').forEach(function(thumbnail, index) {
		const swiperContainer = thumbnail.querySelector('swiper-container');
		let thumbnailId = thumbnail.id;

		if(!thumbnailId) {
			thumbnailId = 'thumbnail-product-' + index;
			thumbnail.setAttribute('id', thumbnailId);
		}

		if(swiperContainer && 'initialize' in swiperContainer) {
			const thumbnailNavs = document.querySelectorAll('#' + thumbnailId + ' .swiper-pagination-custom figure');

			const swiperParams = {
				spaceBetween: 16,
				slidesPerView: 1,
				navigation: {
					nextEl: '#' + thumbnailId + ' .swiper-button-next',
					prevEl: '#' + thumbnailId + ' .swiper-button-prev',
				},
				pagination: {
					el: '#' + thumbnailId + ' .swiper-pagination',
					clickable: true,
					renderBullet: function (index, className) {
						if(thumbnailNavs[index]) {
							thumbnailNavs[index].classList.add(className);

							return thumbnailNavs[index].outerHTML;
						}

						return '';
					},
				},
				on: {
					init() {
						thumbnail.classList.add('thumbnail-product--slider-init');
					},
				},
			};

			Object.assign(swiperContainer, swiperParams);

			swiperContainer.initialize();
		}
	})
})
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["video-embed"] && !Shopify.designMode) return;
  try {
    "use strict";

document.addEventListener("DOMContentLoaded", function() {
    const observer = new IntersectionObserver(
        function (entries, obs) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    const videoEmbed = entry.target;
                    const videoMedia = videoEmbed.querySelector("iframe, video");
                    const videoPoster = videoEmbed.querySelector('figure');

                    if (videoMedia) {
                        const dataSrc = videoMedia.getAttribute("data-src");

                        if (dataSrc) {
                            videoMedia.setAttribute("src", dataSrc);
                            videoMedia.removeAttribute("data-src");

                            // if (videoMedia.tagName.toLowerCase() === 'video') {
                            //     videoMedia.setAttribute("controls", "controls");
                            // }
                        }
                    }

                    if(videoPoster) {
                        videoPoster.style.display = 'none';
                    }

                    obs.unobserve(videoEmbed);
                }
            });
        },
        {
            root: null,
            threshold: 0.1,
        }
    );

    document.querySelectorAll(".video-embed").forEach(function(videoEmbed) {
        const videoMedia = videoEmbed.querySelector('iframe, video');
        const videoPoster = videoEmbed.querySelector('figure');
        const hasPoster = videoEmbed.hasAttribute('data-has-poster');

        if(videoPoster && videoMedia) {
            if(hasPoster) {
                videoEmbed.addEventListener('click', function() {
                    if (!videoEmbed.hasAttribute("data-video-play")) {
                        const dataSrc = videoMedia.getAttribute("data-src");

                        if (dataSrc) {
                            videoMedia.setAttribute("src", dataSrc);
                            videoMedia.removeAttribute("data-src");
                        }

                        if (videoMedia.tagName.toLowerCase() === 'video') {
                            // videoMedia.setAttribute("controls", "controls");
                            videoMedia.play();
                        }

                        videoEmbed.setAttribute("data-video-play", "");
                    }
                });
            } else {
                observer.observe(videoEmbed);
            }
        }
    })
});
  } catch(e) { console.error(e); }
})();

})();
